import React from 'react';
import { Box, Tooltip } from '@mui/material';
import PermissionCheckbox from './PermissionCheckbox';
import { Permission } from '../../../types/permissionType';
import { EntityGroup, EntityGroupTitle } from '../Permissions.styles';
import { useTranslation } from 'react-i18next';

type Props = {
    permissions: Permission[];
    checkedMap: Record<string, boolean>;
    onCheckboxToggle: (perm: Permission, isPerEntity: boolean) => void;
    disabled: boolean;
    isPermissionLocked?: (perm: Permission) => boolean;
};

const GeneralPermissionList: React.FC<Props> = ({ permissions, checkedMap, onCheckboxToggle, disabled, isPermissionLocked }) => {
    const { t } = useTranslation();

    const grouped = React.useMemo(() => {
        return permissions.reduce<Record<string, Permission[]>>((acc, perm) => {
            (acc[perm.entityType] ??= []).push(perm);
            return acc;
        }, {});
    }, [permissions]);

    return (
        <Box>
            {Object.entries(grouped).map(([entityType, perms]) => (
                <EntityGroup key={entityType}>
                    <Tooltip title={t(`permissionsPage.permissionType.${entityType}`)}>
                        <EntityGroupTitle variant="subtitle1">
                            {t(`permissionsPage.permissionType.${entityType}`)}
                        </EntityGroupTitle>
                    </Tooltip>
                    {perms.map((perm) => (
                        <PermissionCheckbox
                            key={`${perm.entityType}.${perm.permissionName}`}
                            permission={{ ...perm, isPerEntity: false }}
                            checked={checkedMap[`${perm.entityType}.${perm.permissionName}`] || false}
                            onChange={() => onCheckboxToggle(perm, false)}
                            disabled={disabled || (isPermissionLocked?.(perm) ?? false)}
                        />
                    ))}
                </EntityGroup>
            ))}
        </Box>
    );
};

export default GeneralPermissionList;
